export default __webpack_public_path__ + "102e7be3b35903ec2dd803beaeceafa1.png";